var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22020",
    "data-name": "Group 22020",
    transform: "translate(-308 -242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18349",
    "data-name": "Rectangle 18349",
    width: 24,
    height: 24,
    transform: "translate(308 242)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-external-link",
    "data-name": "Icon feather-external-link",
    transform: "translate(308.5 242.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36678",
    "data-name": "Path 36678",
    d: "M16.167,14.444v4.667a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,19.111V10.556A1.556,1.556,0,0,1,6.056,9h4.667",
    transform: "translate(0 -2.167)",
    fill: "none",
    stroke: "#43cdc8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36679",
    "data-name": "Path 36679",
    d: "M22.5,4.5h4.667V9.167",
    transform: "translate(-8.667)",
    fill: "none",
    stroke: "#43cdc8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36680",
    "data-name": "Path 36680",
    d: "M15,13.056,23.556,4.5",
    transform: "translate(-5.056)",
    fill: "none",
    stroke: "#43cdc8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateIcon);
export default __webpack_public_path__ + "static/media/navigateIcon.fe12fad624dc9a2d77e232d94d002c1c.svg";
export { ForwardRef as ReactComponent };